import ImageIcon from "../../../../../assets/svg/image";
import PdfIcon from "../../../../../assets/svg/pdf";
import useIsMobile from "../../../../../hooks/use-is-mobile";
import { downloadFile } from "../../../../../utils/download-file";

interface DocumentRowProps {
  downloadKey?: string;
  singpassToken?: string;
  documentType?: string;
  fileName?: string;
  fileSize?: number | null;
  isLastChild?: boolean;
}

function DocumentRow({ downloadKey, singpassToken, documentType, fileName, fileSize, isLastChild = false }: DocumentRowProps) {
  const { isMobile } = useIsMobile();

  return isMobile ? (
    <>
      <span>File name</span>
      {documentType === "pdf" ? <PdfIcon /> : <ImageIcon />}
      <button className="polymer-submission-accordion__document-grid-button" onClick={() => downloadFile(downloadKey ?? "", singpassToken)}>
        <span className="polymer-submission-accordion__document-grid-name">{fileName}</span>
      </button>
      <span>Size</span>
      <div />
      <p className="polymer-submission-accordion__document-grid-size">{getMbValue(fileSize)}</p>
      {!isLastChild ? <div className="polymer-submission-accordion__document-grid-padding" /> : null}
    </>
  ) : (
    <>
      <button className="polymer-submission-accordion__document-grid-button" onClick={() => downloadFile(downloadKey ?? "", singpassToken)}>
        {documentType === "pdf" ? <PdfIcon /> : <ImageIcon />}
        <span className="polymer-submission-accordion__document-grid-name">{fileName}</span>
      </button>
      <p className="polymer-submission-accordion__document-grid-size">{getMbValue(fileSize)}</p>
    </>
  );
}

// Round to 2 decimal places in megabyte
function getMbValue(num: number | null | undefined): string {
  if (!num) return "0 MB";

  return (num / 1000000).toFixed(2) + " MB";
}

export { DocumentRow };
